<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PortfolioNavigation from "@common/Components/PortfolioNavigation.vue";
    import { AlternativesListReadModel } from '@Alternatives/AlternativesLists/Domain/readmodels';
    import AlternativesListsQueries from '@Alternatives/AlternativesLists/Domain/queries-vue-component';
    import AlternativesListsCommands from '@Alternatives/AlternativesLists/Domain/commands-vue-component';
    import { UpdateAlternativeLabelsCommandV1 } from '@Alternatives/AlternativesLists/Domain/commands-core';
    import { ICommandBase } from '@Alternatives/cqrs';

    @Component({
        components: {
            PortfolioNavigation
        }
    })
    export default class AlternativeLabelsEditorPage extends mixins(AlternativesListsQueries, AlternativesListsCommands)
    {
        get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
        get projectId(): number { return Number.parseInt(this.$route.params.projectId); }

        rm: AlternativesListReadModel = null;

        handleUpdateAlternativeLabelsCommand()
        {
            this.invokeUpdateAlternativeLabelsCommandV1(this.workspaceId, this.rm.Id, this.rm.AlternativeLabel, this.rm.AlternativesLabel);
        }


        mounted()
        {   
            document.title = "Labels | TransparentChoice";
            this.runAlternativesListByProjectIdQueryV1(this.workspaceId, this.projectId);
        }


        onSetModel(model: any, modelName: string) 
        {
            if (modelName == "AlternativesListReadModel")
            {
                this.rm = model as AlternativesListReadModel;
            }
        }

        onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
        {
            if (UpdateAlternativeLabelsCommandV1.matchType(cmd))
            {
                alert("saved");
            }
        }

        onCommandFailed(status: any)
        {
            //if (UpdateRequestPageCommandV1.matchType(status.Command))
            //{
            //    for (const error of status.ValidationErrors)
            //    {
            //        alert(error.Error);
            //    }
            //}
        }
    }
</script>

<template>
    <div>

        <PortfolioNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <form @submit.prevent="handleUpdateAlternativeLabelsCommand">

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Edit labels</h1>
                </div>
                <div class="col-lg-6 text-right">
                    <button type="submit" class="btn btn-success" style="padding: 0.7em 2em;">Save changes</button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container" v-if="rm">

            <div class="shadow-none p-3 mb-3 bg-light rounded">
                <p><strong>You can replace the word “alternative” with a more relevant word like “car” or “vendor”.</strong></p>
                <p>
                    “Alternatives” is the word decision scientists use to describe the things you are choosing between.
                    Chances are, you’re not a decision scientist and you’re trying to choose between real-world “things” like cars, the potential sites of a new warehouse or a vendor.
                </p>
            </div>


            <div class="form-group">
                <label>Single alternative:</label>
                <input type="text" v-model.trim="rm.AlternativeLabel" class="form-control" required minlength="2">
                <small class="text-muted">What word would you like to use when talking about just one “alternative”?</small>
            </div>
            <div class="form-group">
                <label>Multiple alternatives:</label>
                <input type="text" v-model.trim="rm.AlternativesLabel" class="form-control" required minlength="2">
                <small  class="text-muted">What word would you like us to use for more than one “alternative”?</small>
            </div>
            
        </div>
        </form>


    </div>
</template>

<style scoped>

</style>


